import React from "react";
import PrevArrow from "../../assets/images/arrow_left.svg";

const SliderPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className={`slick-arrow prev-arrow`} onClick={onClick}>
      <img src={PrevArrow} className="img-fluid" alt="slickPrevArrow" />
    </div>
  );
};

export default SliderPrevArrow;
